import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default (els) => {
    Array.prototype.forEach.call(els, (el) => {
        //console.log(el);

        const tiles = el.querySelectorAll('.grid > div')

        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                end: 'top 30%',
                scrub: 1,
                markers: false,
            },
        });

        timeline.to(tiles, {
            autoAlpha: 0,
            duration: 1,
            stagger: {
                each: 0.185,
                axis: 'y',
                from: 'random',
                grid: 'auto',
                ease: Power1.easeIn,
            },
        });

    });
};